import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { WhiteLabelService } from '@flexyoo/common';
import { getFinancingPlanBadges, IFinancingPlanBadge } from '@flexyoo/shared/functions';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'flexyoo-employee-financing-plan-badge',
  templateUrl: './employee-financing-plan-badge.component.html',
  styleUrl: './employee-financing-plan-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class EmployeeFinancingPlanBadgeComponent {
  private readonly wls = inject(WhiteLabelService);

  readonly pbGrossAmount = input<number>(0);
  readonly ssGrossAmount = input<number>(0);

  protected readonly badges = computed(() =>
    getFinancingPlanBadges({
      pbGrossAmount: this.pbGrossAmount(),
      ssGrossAmount: this.ssGrossAmount(),
    })
  );

  protected readonly hasMultipleBadges = computed(() => this.badges().length > 1);

  protected backgroundColor(badge: IFinancingPlanBadge): string | null {
    if (!badge) {
      return null;
    }
    return badge.colorToken === 'primary' ? 'var(--app-primary-25)' : 'var(--app-warn-25)';
  }

  protected textColor(badge: IFinancingPlanBadge): string | null {
    if (!badge) {
      return null;
    }
    return badge.colorToken === 'primary'
      ? this.wls.primaryContrastingColor
      : this.wls.warnContrastingColor;
  }
}
